








































import {
  defineComponent,
  watch,
  ref,
  toRefs,
  onMounted,
  onUnmounted,
  computed,
  ComputedRef,
  getCurrentInstance,
  ComponentInternalInstance,
  nextTick,
} from '@vue/composition-api';

import { HomeIcon, FileIcon, DesktopIcon, HelpCircleIcon } from 'tdesign-icons-vue';
import ipc from '@/renderer/scripts/utils/ipc';

import getRequest from '@/renderer/scripts/httpRequest';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { CONSTANT_URL, httpUrl } from '@/renderer/scripts/http';
import { IS_DEV, IS_TEST } from '@/common/constant';
import store from '@/renderer/store';
import { isTeamAdmin } from '@/renderer/scripts/utils/UserRole/getters';
import { FILE_MANAGE_ROUTE_LIST } from '@/renderer/scripts/utils/ConstantConfig';
import { i18n_t } from '@/locales/i18n';
import { startGuideSteps } from '@/renderer/scripts/utils/GuideHelper';

export default defineComponent({
  props: {
    showHelpControls: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HomeIcon,
    FileIcon,
    DesktopIcon,
    HelpCircleIcon,
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const { showHelpControls } = toRefs(props);
    const showTooltip = ref(false);
    const question = ref([]);
    const { isPrivate } = store.getters;
    let questionsList: any = null;
    const menuValue = computed(() => vm.$route.meta?.routerParent || vm.$route.name || '');
    const isShowBaseMenu: ComputedRef<boolean> = computed(() => FILE_MANAGE_ROUTE_LIST.includes(menuValue.value));
    const showHelpGuide = computed(() => {
      // 目前有两种情况不显示
      // 1. 在 base 页面，如果没有个人空间
      // 2. 在管理页面，如果是团队管理员
      const hasGuide = !store.getters.isMobile && !store.getters.isMobileStyle && store.getters.hasPersonalSpace;
      if (isShowBaseMenu.value && !hasGuide) {
        return false;
      }
      if (!isShowBaseMenu.value && isTeamAdmin.value) {
        return false;
      }
      return true;
    });
    const methods = {
      showAdminGuide(show: boolean) {
        const steps = [
          {
            id: 'advanceGuide-step-1',
            title: i18n_t('轻松管理企业员工'),
            context: i18n_t('添加新用户和查看现有成员、进行成员权限分配、企业成员空间设置初始化设置'),
            type: 'admin',
          },
          {
            id: 'advanceGuide-step-2',
            title: i18n_t('安全管理企业资产'),
            context: i18n_t('查看用户操作行为、安全外链设置、历史版本恢复、自定义水印设置{slot1}。', {
              slot1: store.getters.enableManageAntivirus ? i18n_t('及安全云查毒，守护企业安全') : '',
            }),
            type: 'admin',
          },
          {
            id: 'advanceGuide-step-3',
            title: i18n_t('全面便捷数据统计'),
            context: i18n_t('查看企业网盘使用情况、企业用户账号规格情况{slot1}。', {
              slot1: !store.getters.isPrivate ? i18n_t('、个人和团队及外网三模块流量使用情况') : '',
            }),
            type: 'admin',
          },
        ];
        nextTick(() => {
          if (show || vm.$route?.params.guide === 'true') {
            startGuideSteps(steps);
            ipc.emit(ipc.RENDERER_EVENTS_MAP.STOP_ADMIN_GUIDE);
          }
        });
      },
      initData() {
        const webUrl = IS_DEV ? 'https://dev.pan.tencent.com' : httpUrl.webUrl;
        try {
          const request = getRequest({ logPrefix: 'Question' });
          const url = `${webUrl}/api/question${IS_DEV || IS_TEST ? '?beta=1' : ''}`;
          request({
            url,
            method: 'get',
          })
            .then(res => {
              const { data } = res;
              questionsList = data;
            })
            .catch();
        } catch (err) {}
      },
      emitFun() {
        context.emit('action', !showHelpControls.value);
      },
      handlerHelp(type: string) {
        methods.emitFun();
        switch (type) {
          case 'productBack':
            methods.openUrl(CONSTANT_URL.productFeedbackUrl);
            break;
          case 'helpControls':
            methods.openUrl('https://cloud.tencent.com/document/product/1599');
            break;
          case 'shortCutKey':
            ipc.emit(ipc.RENDERER_EVENTS_MAP.SHOW_HOT_KEY_DRAWER);
            break;
          case 'reviewGuide':
            context.emit('review');
            break;
          default:
            break;
        }
      },
      openUrl(url: string) {
        context.emit('action', false);
        dispatchRouter(url);
      },
      getQuestion(routerName: string) {
        if (!questionsList) return;
        const manage = [
          'spaceStatistics',
          'userStatistics',
          'trafficStatistics',
          'userManagement',
          'teamManagement',
          'initializeSettings',
          'uiDesign',
          'accountAssociation',
          'customDomain',
          'watermark',
          'consoleLinkManagement',
          'versionManagement',
          'securityScan',
          'logQuery',
        ];

        if (manage.includes(routerName)) {
          question.value = questionsList.manageConsole;
        } else {
          question.value = questionsList[routerName];
        }
      },
      clickDom(event: MouseEvent) {
        const helpControls = document.getElementById('help-controls') as HTMLElement;
        const help = document.getElementById('help') as HTMLElement;
        // 判断被点击的元素是否是目标元素或者目标 div 元素的子元素
        if (event.target === help) return;
        if (showHelpControls.value && helpControls && !helpControls.contains(event.target as Node)) {
          context.emit('action', false);
        }
        // 添加目标 div 元素的 click 事件监听器
        helpControls?.addEventListener('click', e => {
          // 阻止事件向上传递
          e.stopPropagation();
        });
      },
    };

    methods.initData();
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.START_ADMIN_GUIDE, methods.showAdminGuide);
      document.body.addEventListener('click', methods.clickDom);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.START_ADMIN_GUIDE, methods.showAdminGuide);
      document.body.removeEventListener('click', methods.clickDom);
    });
    watch(
      () => context.root.$route.name,
      val => {
        methods.getQuestion(val as string);
      },
      { immediate: true },
    );

    return {
      isPrivate,
      question,
      showTooltip,
      showHelpGuide,
      ...methods,
    };
  },
});
